import { render, staticRenderFns } from "./CarouselInformation.vue?vue&type=template&id=0eede610&scoped=true"
import script from "./CarouselInformation.vue?vue&type=script&lang=js"
export * from "./CarouselInformation.vue?vue&type=script&lang=js"
import style0 from "./CarouselInformation.vue?vue&type=style&index=0&id=0eede610&prod&lang=stylus&scoped=true"
import style1 from "./CarouselInformation.vue?vue&type=style&index=1&id=0eede610&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eede610",
  null
  
)

export default component.exports